import UtilService from "./util.service";
import { HttpService } from "./http.service";
import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import moment from "moment";
import i18n from "../i18n";
import { ToastService } from "../services/toast.service";

const request = HttpService.handleRequest("file");

export const FileHandlerService = {
  DownloadFile,
  UploadFile,
  DownloadFileWithValidate
};

async function DownloadFile(container: string, url: any, data: RequestInputOutputParamsModel, type: any, endString: string = "", setnamefile:string = "") {
  const t = i18n.t;
  return new Promise((resolve, reject) => {
    request({
      url: url,
      method: "POST",
      data: data,
      responseType: "blob",
      timeout: 1000 * 360, // Wait for 5 seconds
    })
      .then((response: { data: BlobPart; }) => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        let mime = type === "Excel" ? ".xlsx" : "." + type.toLowerCase();

        
        var now = new Date();
        var dateStringWithHour = UtilService.toExportDateFormated(now);

        link.href = url;

        if (setnamefile == "")
        {
          link.setAttribute("download", t(container.toUpperCase().replace("/", "") + '.EXPORT_FILE_NAME_PREFIX') + '_' + (endString ? endString : dateStringWithHour) + mime);
        }
        else
        {
          link.setAttribute("download", t(setnamefile.toUpperCase().replace("/", "") + '.EXPORT_FILE_NAME_PREFIX') + '_' + (endString ? endString : dateStringWithHour) + mime);
        }
        

        document.body.appendChild(link);

        link.click();

        resolve(true);
      })
    .catch((error: any) => {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        window.location.href = "/login"; // redirect
        return;
      }
      reject(error);
    });
  });
}

async function UploadFile(url: any, file: any) {
  return new Promise((resolve, reject) => {
    request({
      url: url,
      method: "POST",
      data: file,
      responseType: "json"
    })
      .then((response: any) => {
        resolve(response.data.success);
      })
      .catch((error: any) => {
        reject(error);
      });
  }
  );
}

async function DownloadFileWithValidate(container: string, url: any, data: RequestInputOutputParamsModel, type: any, endString: string = "", setnamefile:string = "") {
  const t = i18n.t;
  return new Promise((resolve, reject) => {
    request({
      url: url,
      method: "POST",
      data: data,
      responseType: "blob",
      timeout: 1000 * 360, // Wait for 5 seconds
    })
      .then((response: { data: BlobPart; headers: any}) => {

        const contentType = response.headers["content-type"];

        if (contentType && contentType.includes("application/json")) {
            // Cria um Blob explícito a partir do response.data
            const blob = new Blob([response.data]);
            const reader = new FileReader();
            reader.onload = () => {
                const text = reader.result as string;
                const json = JSON.parse(text);
                if (json.result && json.result.length > 0) {
                    ToastService.warn(json.result[0].message, null);
                }
                resolve(json); // retorna ResultRequest
            };
            reader.readAsText(blob);
            return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        let mime = type === "Excel" ? ".xlsx" : "." + type.toLowerCase();

        
        var now = new Date();
        var dateStringWithHour = UtilService.toExportDateFormated(now);

        link.href = url;

        if (setnamefile == "")
        {
          link.setAttribute("download", t(container.toUpperCase().replace("/", "") + '.EXPORT_FILE_NAME_PREFIX') + '_' + (endString ? endString : dateStringWithHour) + mime);
        }
        else
        {
          link.setAttribute("download", t(setnamefile.toUpperCase().replace("/", "") + '.EXPORT_FILE_NAME_PREFIX') + '_' + (endString ? endString : dateStringWithHour) + mime);
        }
        

        document.body.appendChild(link);

        link.click();

        resolve(true);
      })
    .catch((error: any) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          window.location.href = "/login"; // redirect
          return;
        }
        reject(error);
      });
  });
}

export default FileHandlerService;